import { fetchCountries as fetchCountriesFromAPI } from '@/api/routing'

/**
 * Fetch all countries from the API if they haven´t been loaded yet.
 * Access the collection by using the getter 'countries/countries'
 */
const loadCountries = async ({commit, dispatch, state}) => {
  if (state.countries === null || Object.keys(state.countries).length === 0) {
    await dispatch('fetchCountries')
  }
}

/**
 * Hard refresh of countries
 */
const fetchCountries = async ({commit}) => {
  let response = await fetchCountriesFromAPI()
  commit('SET_COUNTRIES', response)
}

export default {
  loadCountries,
  fetchCountries
}



// WEBPACK FOOTER //
// ./src/store/modules/countries/actions.js